import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import banner from "../../images/banner2.png";

const Container = styled.div`
  ${tw`relative flex flex-col flex-wrap bg-cover`}
`;

const ThreeColumnContainer = styled.div`
  ${tw`relative flex flex-col items-center flex-wrap max-w-screen-lg mx-auto pb-0`}
`;

// Page's single h1: this is the only place HeaderImageAndText is used, so this is safe as the one h1 per page.
const Heading = tw.h1`text-4xl sm:text-5xl font-black tracking-wide text-center w-full`;

const ImageContainer = styled.a`
    ${tw`text-center`}
`;

export default ({ heading = "Amazing Features" }) => {

  return (
    <Container>
      <ImageContainer>
        <img src={banner} alt="" />
      </ImageContainer>
      <ThreeColumnContainer>
        <Heading>{heading}</Heading>
      </ThreeColumnContainer>
    </Container>
  );
};
